import {FC, useRef, useState} from 'react';
import {Trans, useTranslation} from 'react-i18next';
import UserListPopup from 'pages/Portal/components/UserListPopup';

interface InboxSectionSubtitleProps {
    canEdit: boolean;
    clientUsers: string[];
    partnerName: string;
    portalMid: string;
}

const InboxSectionSubtitle: FC<InboxSectionSubtitleProps> = ({
    canEdit,
    clientUsers,
    partnerName,
    portalMid,
}) => {
    const {t} = useTranslation('Portal');

    const [show, setShow] = useState(false);
    const refHeading = useRef<HTMLSpanElement>(null);
    const refLink = useRef<HTMLSpanElement>(null);

    return (
        <>
            <span ref={refHeading}>
                <Trans
                    components={[
                        <span
                            key={0}
                            ref={refLink}
                            aria-label="Open User List Popup"
                            className="text-green-700 hover:text-green-700 hover:underline cursor-pointer select-none"
                            onClick={() => {
                                if (!show) setShow(true);
                            }}
                            onKeyPress={() => {}}
                            role="button"
                            tabIndex={0}
                        />,
                    ]}
                    i18nKey="clientInbox.subtitle"
                    t={t}
                />
            </span>
            <UserListPopup
                canEdit={canEdit}
                clientUsers={clientUsers}
                partnerName={partnerName}
                portalMid={portalMid}
                refHeading={refHeading}
                refLink={refLink}
                setShow={setShow}
                show={show}
            />
        </>
    );
};

export default InboxSectionSubtitle;
